__webpack_require__.p = "/onboarding2-ui/";